import React, { useState, useEffect, memo } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import {
  deleteComment,
  getComments,
  insertComment,
  updateComment
} from '../../services/otherServices';
import UserContext from './../../context/userContext';
import TextArea from './../common/textArea';
import { Check, X, Edit3, Trash2 } from 'react-feather';
import CommentLoader from './../content-loader/commentsLoader';
import { largeDate } from './../../utils/constants';
import { custom1 } from './../../utils/constants';
import { error } from './../common/toast';

const SummaryComment = (props) => {
  const [data, setData] = useState({
    comments: [],
    noComments: false,
    shownewcomment: false
  });

  useEffect(() => {
    async function getData() {
      try {
        const { data } = await getComments(props.id);
        setData({
          comments: data,
          noComments: false,
          shownewcomment: false
        });
      } catch (err) {
        setData({
          comments: [],
          noComments: true,
          shownewcomment: false
        });
      }
    }
    getData();
  }, [props.id]);

  //Function 1: On submit, create entry
  const submit = async (user) => {
    let usercomment = document.getElementById('usercomment').value;
    if (usercomment.trim().length === 0) {
      error('Empty comment is not allowed');
      return false;
    } else if (usercomment.trim().length >= 1000) {
      error('Please enter comment less than 1000 characters');
      return false;
    }
    let newcmt = {
      anomaly_id: props.id,
      comment: usercomment.trim(),
      email: user.email,
      display_name: user.last_name + ', ' + user.first_name,
      last_updated: new Date().toLocaleString(undefined, largeDate),
      user_uuid: user.user_uuid
    };
    let cmt = [...data.comments, newcmt];
    let rollback = [...data.comments];
    setData({
      comments: cmt,
      noComments: false,
      shownewcomment: false
    });
    try {
      let { data: result } = await insertComment(
        usercomment,
        props.id,
        'summary'
      );
      let cmt = [...data.comments, result]; //to delete the inserted comment, comment id is set here
      setData({
        comments: cmt,
        noComments: false,
        shownewcomment: false
      });
    } catch (err) {
      setData({
        comments: rollback,
        noComments: false,
        shownewcomment: false
      });
    }
  };

  //Function 2: Delete entry
  const deleteCmt = async (comment) => {
    let rollback = [...data.comments];
    let cmt = rollback.filter((s) => s.id !== comment.id);
    setData({
      comments: cmt,
      noComments: false,
      shownewcomment: false
    });
    try {
      await deleteComment(comment.id);
      if (cmt.length === 0)
        setData({
          comments: cmt,
          noComments: true,
          shownewcomment: false
        });
    } catch (err) {
      setData({
        comments: rollback,
        noComments: false,
        shownewcomment: false
      });
    }
  };

  //Function 3: Show/hide comment input bpx
  const ShowNew = (show) => {
    setData({
      comments: data.comments,
      noComments: data.noComments,
      shownewcomment: show
    });
  };

  //Function 4: Edit comment
  const editCmt = (record) => {
    let comment = document.getElementById(record.id + '_comment');
    let edit = document.getElementById(record.id + '_update');
    comment.classList.toggle('d-none');
    edit.classList.toggle('d-none');
  };

  //Function 5: Edit comment
  const submitUpdate = async (record) => {
    let usercomment = document.getElementById(record.id + '_usercomment').value;
    if (usercomment.trim().length === 0) {
      error('Empty comment is not allowed');
      return false;
    } else if (usercomment.trim().length >= 1000) {
      error('Please enter comment less than 1000 characters');
      return false;
    }
    let comments = [...data.comments];
    comments.forEach((s) => {
      if (s.id === record.id) {
        s.comment = usercomment.trim();
      }
    });
    let rollback = [...data.comments];
    editCmt(record);
    try {
      await updateComment(usercomment, record.id);
      setData({
        comments: comments,
        noComments: false,
        shownewcomment: false
      });
    } catch (err) {
      setData({
        comments: rollback,
        noComments: false,
        shownewcomment: false
      });
    }
  };

  return (
    <UserContext.Consumer>
      {(userContext) => {
        const { user } = userContext;
        const NewComment = (
          <Col xs={12} md={12} lg={12} className='d-flex fadeInDown'>
            <Col xs={11} md={11} lg={11}>
              <TextArea
                name='usercomment'
                placeholder='Enter your comment'
                customclass='textarea-custom'
              />
            </Col>
            <Col xs={1} md={1} lg={1} className='commentAction'>
              <Button
                variant='success'
                className='mb-2'
                onClick={() => submit(user)}
              >
                <Check />
              </Button>
              <Button variant='danger' onClick={() => ShowNew(false)}>
                <X />
              </Button>
            </Col>
          </Col>
        );
        const Title = (
          <Col xs={12} md={12} lg={12} className='mb-3 d-flex'>
            <h6 className='flex-fill'>Comments on the alert</h6>
            {!data.shownewcomment && (
              <Button className='pt-1 pb-1' onClick={() => ShowNew(true)}>
                + comment
              </Button>
            )}
          </Col>
        );

        return (
          <Row className='m-0 p-0 mt-4' id='summaryComment'>
            {Title}
            {data.shownewcomment && NewComment}
            {!data.noComments && data.comments.length !== 0 && (
              <div className='holder'>
                {data.comments.map((record, i) => {
                  const displayname = record.display_name;
                  const name = record.display_name.split(', ');
                  const shortname = name[1][0] + name[0][0];
                  const date = record.created_date;
                  const showDelete =
                    user.user_uuid === record.user_uuid ? true : false;
                  const deleteSize =
                    user.user_uuid === record.user_uuid ? 10 : 12;
                  //Component 1: Comment Editor
                  const updateComment = (
                    <Row
                      className='m-0 d-none fadeInDown'
                      id={record.id + '_update'}
                    >
                      <Col
                        xs={deleteSize}
                        md={deleteSize}
                        lg={deleteSize}
                        className='comment p-0'
                      >
                        <TextArea
                          name={record.id + '_usercomment'}
                          placeholder='Enter your comment'
                          customclass='textarea-custom h70'
                          value={record.comment}
                        />
                      </Col>
                      <Col xs={1} md={1} lg={1} className='commentAction'>
                        <Button
                          variant='success'
                          className='mb-2'
                          onClick={() => submitUpdate(record)}
                        >
                          <Check />
                        </Button>
                        <Button
                          variant='danger'
                          onClick={() => editCmt(record)}
                        >
                          <X />
                        </Button>
                      </Col>
                    </Row>
                  );
                  //Main Return
                  return (
                    <Row className='m-0 mr-3 ml-3 mb-2 commentCard' key={i}>
                      <p
                        className='commentorShort'
                        style={{ color: `#${custom1[i]}` }}
                      >
                        {shortname}
                      </p>
                      <div className='info'>
                        <Row className='m-0 mb-1' style={{ fontWeight: 500 }}>
                          <Col
                            xs={12}
                            md={6}
                            lg={6}
                            className='commentor'
                            style={{ color: `#${custom1[i]}` }}
                          >
                            {displayname}
                          </Col>
                          <Col xs={12} md={6} lg={6} className='commentDate'>
                            {date}
                          </Col>
                        </Row>
                        <Row
                          className='m-0 fadeInDown'
                          id={record.id + '_comment'}
                        >
                          <Col
                            xs={deleteSize}
                            md={deleteSize}
                            lg={deleteSize}
                            className='comment p-0'
                          >
                            {record.comment}
                          </Col>
                          {showDelete && (
                            <>
                              <Col xs={1} md={1} lg={1} className='editComment'>
                                <Edit3
                                  size={18}
                                  onClick={() => editCmt(record)}
                                />
                              </Col>
                              <Col xs={1} md={1} lg={1} className='delComment'>
                                <Trash2
                                  size={18}
                                  onClick={() => deleteCmt(record)}
                                />
                              </Col>
                            </>
                          )}
                        </Row>
                        {showDelete && updateComment}
                      </div>
                    </Row>
                  );
                })}
              </div>
            )}

            {!data.noComments && data.comments.length === 0 && (
              <div className='pl-3 pr-3'>
                <CommentLoader />
              </div>
            )}

            {data.noComments && data.comments.length === 0 && (
              <div className='nocomments'>No comments</div>
            )}
          </Row>
        );
      }}
    </UserContext.Consumer>
  );
};

export default memo(SummaryComment);
